import {AnalyticsProvider} from '@github-ui/analytics-provider'
import {PreviewCardOutlet} from '@github-ui/preview-card'
import {Outlet} from '@github-ui/react-router'

export function RepoPullsDashboardLayout() {
  return (
    <AnalyticsProvider
      appName="repo-pulls-dashboard-surface"
      category="Repository Pull Requests"
      metadata={{page: 'repo-pulls-dashboard'}}
    >
      <div data-issue-and-pr-hovercards-enabled>
        <Outlet />
        <PreviewCardOutlet />
      </div>
    </AnalyticsProvider>
  )
}
